<template>
  <div>
    <!-- 头部导航 -->
    <HeaderPage href="/" />
    <div class="container_wrap">
      <!-- banner -->
      <TheBanner :images="banners" :interval="4000" />

      <!-- 公司介绍 -->
      <div style="width:100%;background:#f7f7f7;">
        <div class="wrap">
          <div class="content-wrap">
            <div class="box flex wow" data-animate="fadeInUp">
              <div class="pic">
                <img src="@/assets/home1.jpg" alt="浙江国正安全技术有限公司">
              </div>
              <div class="textBox">
                <div class="tit">
                  <h2>浙江国正安全技术有限公司</h2>
                </div>
                <div class="text">
                  <div class="mb10">
                    位于浙江省绍兴市柯桥区齐贤镇高泽镜水路1906号物流大厦，是一家以安全评价、职业卫生检测与评价、环境保护检测和安全生产技术服务为主体的综合类高新技术企业，具有独立的法人资格。公司办公面积2256㎡。
                  </div>
                  <div>
                    公司内设安全评价部、职业健康事业部、环境事业部、电子电气事业部、质量管理部、安全技术服务事业部、市场营销部、理化分析中心、财务部和综合办。
                  </div>
                </div>
                <div class="more-wrap">
                  <a href="/about">更多</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 公司信息 -->
      <div style="width:100%;background:#fff;">
        <div class="wrap">
          <div class="company-info-container">
            <div class="info-item wow" data-animate="fadeInUp">
              <img src="@/assets/images/roxZbS.png" alt="办公面积" class="mb10" />
              <h2>2256m²</h2>
              <p class="desc">
                安全评价、职业卫生检测与评价、环境保护检测、安全生产技术服务为主体的综合类高新技术企业
              </p>
            </div>
            <div class="info-item wow" data-animate="fadeInUp">
              <img src="@/assets/images/6iBIzf.png" alt="技术人员" class="mb10" />
              <h2>技术人员85人</h2>
              <p class="desc">
                有建材、化工、机械、电气、消防、矿山、冶金、仪表、土木、职业卫生、安全等专业的技术人员
              </p>
            </div>
            <div class="info-item wow" data-animate="fadeInUp">
              <img src="@/assets/images/Afn5Vr.png" alt="检验保障" class="mb10" />
              <h2>检验保障1000+</h2>
              <p class="desc">
                公司是经浙江省应急管理厅批准的安全评价机构，证书编号为APJ-(浙)-007。是经浙江省生态环境厅、绍兴市生态环境局认可的社会环境检测机构。
              </p>
            </div>
            <div class="info-item wow" data-animate="fadeInUp">
              <img src="@/assets/images/Qo6CLQ.png" alt="服务客户" class="mb10" />
              <h2>服务客户20000+</h2>
              <p class="desc">
                浙江国正安全技术有限公司是一家受社会尊敬、让员工自豪、新时代一流的高新技术企业
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 国正动态 -->
      <div class="ft-container">
        <div class="wrap">
          <div class="title wow" data-animate="fadeInUp">
            <h3>NEWS & EVENTS</h3>
            <h2>国正动态</h2>
          </div>

          <div class="box flex wow" data-animate="fadeInUp">
            <!-- 公司新闻 -->
            <div class="indexNews">
              <div class="tit">
                <h3>公司新闻</h3>
              </div>

              <div class="boxCon1" v-if="newsData.length">
                <!-- 只显示一条最新的新闻 -->
                <router-link
                  :to="`/news/details?type=${newsData[0].type}&title=${newsData[0].title}`">
                  <div class="newtit">{{ newsData[0].title }}</div>
                  <dd class="newtime">{{ formatDate(newsData[0].createTime) }}</dd>
                  <div class="text" v-html="newsData[0].content"></div>
                </router-link>

                <!-- 更多按钮 -->
                <router-link :to="`/news/details?type=${newsData[0].type}`" class="more-n">更多</router-link>
              </div>
              <!-- 无数据时 -->
              <div v-else class="no-data">暂无新闻</div>
            </div>

            <!-- 网上信息公开 -->
            <div class="indexIinformation">
              <div class="tit">
                <h3>网上信息公开</h3>
              </div>

              <div class="boxCon2">
                <ul>
                  <li v-for="item in companyData.slice(0, 3)" :key="item.id">
                    <router-link :to="`/companynews/detail?type=${item.type}&id=${item.id}`">
                      <h3>{{ item.title }}</h3>
                      <ol>
                        <dd>{{ formatDate(item.createTime) }}</dd>
                        <span>MORE+</span>
                      </ol>
                    </router-link>
                  </li>
                </ul>

                <!-- 更多按钮 -->
                <router-link to="/companynews?id=3" class="more-i">更多</router-link>

                <!-- 无数据提示 -->
                <div v-if="!companyData.length" class="no-data">暂无数据</div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- 服务项目 -->
      <div class="indexFour">
        <div class="wrap">
          <div class="title wow" data-animate="fadeInUp">
            <h3>PROFESSIONAL SERVICE</h3>
            <h2>服务项目</h2>
          </div>

          <div class="box wow" data-animate="fadeInUp">
            <ul class="flex">
              <li>
                <div class="item">
                  <i><img src="@/assets/images/dIbPzMbI.png" alt="" /></i>
                  <h3>安全</h3>
                  <div class="text">
                    <a href="/products/detail?id=1">
                      <p>安全评价</p>
                    </a>
                    <a href="/products/detail?id=2">
                      <p>安全技术服务承诺书</p>
                    </a>
                    <a href="/products/detail?id=3">
                      <p>安全生产标准化咨询</p>
                    </a>
                    <a href="/products/detail?id=4">
                      <p>安全生产标准化评审</p>
                    </a>
                    <a href="/products/detail?id=5">
                      <p>电气防爆安全检测</p>
                    </a>
                    <a href="/products/detail?id=6">
                      <p>安全评价收费标准</p>
                    </a>
                  </div>
                </div>
              </li>

              <li>
                <div class="item">
                  <i><img src="@/assets/images/wfjAG8Cl.png" alt="" /></i>
                  <h3>职业卫生</h3>
                  <div class="text">
                    <a href="/products/detail?id=7">
                      <p>职业卫生预评价</p>
                    </a>
                    <a href="/products/detail?id=8">
                      <p>职业卫生控制效果评价</p>
                    </a>
                    <a href="/products/detail?id=9">
                      <p>职业卫生现状评价</p>
                    </a>
                    <a href="/products/detail?id=10">
                      <p>职业病危害因素定期检测</p>
                    </a>
                  </div>
                </div>
              </li>

              <li>
                <div class="item">
                  <i><img src="@/assets/images/A2ryKxbc.png" alt="" /></i>
                  <h3>环境</h3>
                  <div class="text">
                    <a href="/products/detail?id=11">
                      <p>噪声</p>
                    </a>
                    <a href="/products/detail?id=12">
                      <p>辐射</p>
                    </a>
                    <a href="/products/detail?id=13">
                      <p>照度</p>
                    </a>
                    <a href="/products/detail?id=14">
                      <p>公共卫生</p>
                    </a>
                    <a href="/products/detail?id=15">
                      <p>水和废水</p>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <FooterPage />
  </div>
</template>

<script setup>
import HeaderPage from '@/components/HeaderPage.vue'
import FooterPage from '@/components/FooterPage.vue'
import { ref, onMounted, onUnmounted } from 'vue'
import TheBanner from '@/components/TheBanner .vue'
import home from '@/assets/home.png'
import './index.css'
import { getWebsiteData } from '@/utils/api';

const banners = [
  home
]

// banner 自动轮播逻辑
const images = ['home']
const currentIndex = ref(0)
const itemWidth = ref(0)

let intervalId

const handleNext = () => {
  currentIndex.value = (currentIndex.value + 1) % images.length
}
const startAutoScroll = () => {
  intervalId = setInterval(handleNext, 3000)
}
const stopAutoScroll = () => {
  clearInterval(intervalId)
}

// 格式化日期
const formatDate = (dateStr) => {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const companyData = ref([])
const newsData = ref([])
// 获取数据的方法
const fetchData = async () => {
  try {
    const res1 = await getWebsiteData(
      {
        type: 1
      }
    )
    newsData.value = res1.data.list
    const res2 = await getWebsiteData({
      type: 3
    })
    companyData.value = res2.data.list
    // // 根据接口返回格式处理数据
    // if (response && response.data) {
    //   const data = response.data.list
    //   // 筛选 type = 1 新闻
    //   newsData.value = data.filter(item => +item.type === 1)

    //   // 筛选 type = 3 网上信息公开
    //   companyData.value = data.filter(item => +item.type === 3)
    // }
  } catch (error) {
    console.error('获取数据失败：', error);
  }
}

onMounted(() => {
  // 获取数据
  fetchData()

  // 动画
  const img = document.querySelector('.banner-wrapper img')
  if (img) itemWidth.value = img.offsetWidth
  startAutoScroll()

  // ✅ 滚动动画逻辑
  const elements = document.querySelectorAll('.wow')
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target
        const animateName = el.dataset.animate || 'fadeInUp'
        if (entry.isIntersecting) {
          el.classList.add('animated', animateName)
          // ✅ 添加后立即取消观察，避免重复触发
          observer.unobserve(el)
        }
      })
    },
    { threshold: 0.2 }
  )
  elements.forEach((el) => observer.observe(el))
  onUnmounted(() => {
    elements.forEach((el) => observer.unobserve(el))
    stopAutoScroll()
  })
})
</script>

<style scoped>
/* 动画基础样式 */
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes fadeInUp {
  from {
    transform: translate3d(0, 100%, 0);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.fadeInUp {
  animation-name: fadeInUp;
}

/* 其他样式保持不变 */
.more {
  position: absolute;
  right: 0;
  bottom: -25px;
  width: 50px;
  height: 50px;
  background: #c1a25f url(@/assets/images/icon05.png) no-repeat center;
  display: block;
  font-size: 0;
  transition: all 0.4s;
}

.more-n {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 50px;
  height: 50px;
  background: #c1a25f url(@/assets/images/icon05.png) no-repeat center;
  display: block;
  font-size: 0;
  transition: all 0.4s;
}

.more-i {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 50px;
  height: 50px;
  background: #c1a25f url(@/assets/images/icon05.png) no-repeat center;
  display: block;
  font-size: 0;
  transition: all 0.4s;
}

.flex {
  display: flex;
}

/* 省略... 你原有的 CSS 全部保留 */

.boxCon1 {
  background-color: #fafafa;
  padding: 50px;
  height: 300px;
  box-sizing: border-box;
}

.boxCon1 .newtime {
  color: #999999;
  margin-bottom: 15px;
}

.boxCon1 .newtit {
  font-size: 18px;
  color: #000;
  font-weight: 500;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 10px;
}

.boxCon1 .text {
  height: 90px;
  color: #333;
  line-height: 30px;
  margin-bottom: 30px;
  overflow: hidden;
  margin-top: 10px;
}

.indexIinformation {
  width: 65%;
  padding-left: 70px;
  position: relative;
}

.indexIinformation .boxCon2 {
  padding-bottom: 50px;
}

.indexIinformation .boxCon2 ul li {
  border-bottom: #f7f2f2 solid 1px;
}

.indexIinformation .boxCon2 ul li h3 {
  font-size: 16px;
  color: #333;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 10px;
  transition: all 0.4s;
}

.indexIinformation .boxCon2 ul li a {
  padding: 20px 0;
  display: block;
}

.indexIinformation .boxCon2 ul li ol {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.indexIinformation .boxCon2 ul li ol dd {
  color: #999;
}

.indexIinformation .boxCon2 ul li ol span {
  width: 100px;
  height: 35px;
  font-size: 15px;
  line-height: 33px;
  text-align: center;
  color: #990000;
  border: #990000 solid 1px;
  border-radius: 4px;
  display: block;
}

.indexFour {
  padding: 60px 0;
  background: url(@/assets/images/indexFourBg.jpg) no-repeat center;
  background-size: cover;
}

.indexFour .wrap {
  width: 100%;
  margin: 0 auto;
}

.indexFour .title {
  text-align: center;
  margin-bottom: 50px;
}

.indexFour .title h3 {
  font-size: 38px;
  line-height: 1;
  color: #003366;
  font-weight: 500;
  border-bottom: #003366 solid 1px;
  display: inline-block;
  padding: 0 50px 15px;
  margin-bottom: 15px;
}

.indexFour .title h2 {
  font-size: 35px;
  line-height: 1;
  color: #c1a25f;
  font-weight: 500;
}

.indexFour .box {
  padding: 0 30px;
}

.indexFour .box ul {
  width: 100%;
}

.indexFour .box ul li {
  flex: 1;
  padding: 0 30px;
}

.indexFour .item {
  height: 100%;
  padding: 0 45px 45px;
  background: #f5f5f5;
  transition: all 0.4s;
}

.indexFour .item i {
  width: 110px;
  height: 110px;
  line-height: 110px;
  text-align: center;
  background: #00437c;
  display: block;
}

.indexFour .item h3 {
  font-size: 36px;
  border-bottom: #a88333 solid 2px;
  padding: 20px;
  margin-bottom: 30px;
}

.indexFour .item .text {
  font-size: 18px;
}

.indexFour .item .text p {
  margin-bottom: 13px;
}

.indexFour .item .text p::before {
  content: "▪";
  font-size: 14px;
  margin-right: 15px;
}
</style>
